import React, { Component } from 'react';

class Alert extends Component {
  constructor() {
	super();
	this.state = {
	  items: []
	};
  }

  componentDidMount() {
  }

  render() {
	let item = this.props.item;
	
	return (
		<div className={ item.unread ? 'alert alert-unread' : 'alert' }>
			<div className="alert-thumb">
				<img alt="" className="alert-img" src={item.getImg()} />
			</div>
			<div className="alert-info">
				<div className="pull-right text-right">
					<div>{item.getExpires()}m</div>
					<div><img alt="" className="alert-credits-img" src="credits.png" />{ item.credits }</div>
				</div>
				<div>
					{ item.getType() !== 3 && item.getType() !== 4 ? 
						(<a href={item.getWikiaLink()} target="_blank">{ item.drop }</a>)
						:
						(item.drop ? item.drop : 'No drop')
					}
				</div>
				<div>{ item.location }</div>
			</div>
		</div>
	);
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert.js